// The landing page's story order (#5128, founder pick A of #5093) and its
// flag, landing_story. A rollout gate, not a kill switch; retire it once it
// is on for everyone (ADR 0038), with the old order, in one PR.
//
// The page is signed out and prerendered, so "Just us" cannot reach it by
// account: only Everyone does (a public flag, seeded into the prerendered
// HTML at build time, so the first paint already carries the order). That
// is why the go-live is the flag AND a frontend deploy: the flag alone would
// paint today's page and then swap (skill app-page rule 3b).
//
// The team previews it on a team device with ?landing_preview=1 (the
// founder on his phone): kept for this tab, read after mount so the first
// render still matches the prerendered markup, and never on a stranger's
// browser (isOurBrowser: the team marker, or an automated browser).
// ?landing_preview=0 ends it.
import { useEffect, useState } from 'react';
import { isOurBrowser } from '../services/analytics';

export const LANDING_STORY_FLAG = 'landing_story';
export const LANDING_PREVIEW_PARAM = 'landing_preview';
const PREVIEW_KEY = 'stratia_landing_preview';

/** Whether this tab asked for the preview, on a team device. Never throws. */
export function landingPreviewRequested() {
    try {
        const ask = new URLSearchParams(window.location.search).get(LANDING_PREVIEW_PARAM);
        if (ask === '1') sessionStorage.setItem(PREVIEW_KEY, '1');
        if (ask === '0') sessionStorage.removeItem(PREVIEW_KEY);
        return sessionStorage.getItem(PREVIEW_KEY) === '1' && isOurBrowser();
    } catch {
        return false;
    }
}

/** Pure: the story order shows when the flag is on for everyone, or in a preview. */
export function landingStoryOn({ publicFlags, preview = false }) {
    return Boolean(publicFlags?.[LANDING_STORY_FLAG]) || Boolean(preview);
}

/** The page's answer: the public flag at once, the preview after mount. */
export default function useLandingStory(publicFlags) {
    const [preview, setPreview] = useState(false);
    useEffect(() => { setPreview(landingPreviewRequested()); }, []);
    return landingStoryOn({ publicFlags, preview });
}
